import * as React from 'react'
import * as Styles from './partnersBlock.module.scss'
import c from 'classnames'

const Layout = ({ section, images }) => {
	const pagedata = section.attributes.data;
	let buttonText = pagedata.partners_button_text;
	let buttonLink = pagedata.partners_button_link.url;
	let title = pagedata.partners_title;
	let bgAlt = pagedata.partners_bg_alt;
	let left = pagedata.partners_align_left;
	let just = pagedata.partners_justification;
	let content = pagedata.partners_content;
	let image = getImageUrl(pagedata.partners_image);

	function getImageUrl(id) {
		for (var i = 0; i < images.length; i++){
			if (images[i].node.databaseId === id){
			   return images[i].node.sourceUrl;
			}
		}
	}

	return (
		<div className={c("section", {'bg-alt': bgAlt == 1})}>
			<div className={c("text-image-block container items-center", {'flex-reverse': left == 1})}> 
				<div className={c("col col-md-1-2", {'align-text-center': just == 1})}>
					{
						(title) ? 
							<h2 className={Styles.textBlockTitle}>{title}</h2> 
						: ''
					}
					<div className="textBlockInner">
						{
							(content) ? 
								<div dangerouslySetInnerHTML={{__html: content}}></div>
							: ''
						}
						<ul className="flex list--unstyled flexwrap justify-center items-center no-bm">
							<li class="partner-logo">
								<img width="122" height="27" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2022/06/petsbest.svg" alt="Pets Best" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="122" height="27" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2022/06/lemonade.svg" alt="Lemonade" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="116" height="25" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2023/12/paw-protect.svg" alt="Paw Protect" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="102" height="35" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2022/06/figo.svg" alt="Figo" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="122" height="31" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2025/05/logo_hppi.webp" alt="Healthy Paws" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="121" height="30" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2025/04/fetch-logo.svg" alt="Fetch" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="79" height="35" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2023/03/spotreal.svg" alt="Spot" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="112" height="31" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2024/04/embrace-1.svg" alt="Embrace" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="112" height="29" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2024/04/pumpkin_logo_blue.svg" alt="Pumpkin" loading="lazy" />
							</li>
							<li class="partner-logo">
								<img width="122" height="16" src="https://dev-petted2.pantheonsite.io/wp-content/uploads/2024/04/aphi_logo_orange.svg" alt="ASPCA" loading="lazy" />
							</li>
						</ul>
					</div>
					{
						(buttonLink) ? 
							<a href={buttonLink} className="btn btn--slim">{buttonText}</a>
						: ''
					}
				</div>
				<div className="col col-md-1-2 align-text-center med-up">
					<div className="image-mask">
						<img src={image} alt="Dog image" loading='lazy'/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Layout